export const ADD_NEW_SUBSCRIPTION = "ADD_NEW_SUBSCRIPTION"
export const ADD_SUBSCRIPTION_SUCCESS = "ADD_SUBSCRIPTION_SUCCESS"
export const ADD_SUBSCRIPTION_FAIL = "ADD_SUBSCRIPTION_FAIL"

export const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS"
export const GET_SUBSCRIPTIONS_SUCCESS = "GET_SUBSCRIPTIONS_SUCCESS"
export const GET_SUBSCRIPTIONS_FAIL = "GET_SUBSCRIPTIONS_FAIL"